import React, { Component } from 'react';
import {withRouter} from 'react-router';
import AppButton from './AppButton';
import { Address } from './Address'
import AuthService from "../services/AuthService";
import ConfirmRedirect from './ConfirmRedirect';
import ActivityLocation from './ActivityLocation';
import './Redirect.scss';
import ConfigService from "../services/ConfigService";
import UtilService from "../services/UtilService";
import AuthorityToLeave from './AuthorityToLeave';

class Redirect extends Component {
    static displayName = Redirect.name;

    constructor(props) {
        super(props);
        const { match: { params, search } } = props;
        
        this.state = {
            loaded: false,
            notFound: false,
            to: {   
                Address: {
                    Id: 0, 
                    Addr: null,
                    address_type: "RES",
                    suburb: { name: "", pcode: "", depot: { code:"", name:""} }, 
                    Address1: "", 
                    Address2: "",
                    Name: ""
                },
                Contact: {
                    Name: "",
                    Mobile : "",
                    Email: ""
                },             
                Instruction: ""
            },
            shipment: {
                connote: "",
                status: 0,
                from: {},
                to: {},
                additionalServices: []
            },
            offer: {
                offers: [{}]                
            },
            config: {
                termsAndConditions: {
                    // default but will be overriden by config
                    authorityToLeaveUrl: "http://www.fliway.com/media/5413/fliway-termsandconditions-dec17.pdf",
                    additionalServicesUrl: "http://www.fliway.com/media/5413/fliway-termsandconditions-dec17.pdf"
                }
            },
            acceptTerms: false,
            token: (params || {jobid: null}).jobid,
            params: params || {jobid: null},
            authenticatedUser: null,
            RedirectPrice: {redirectionServices: []}
        };
    }   
  
    loadServices = async () => {
        var services = this.state.shipment.additionalServices;        
        console.log('Additional services', services);
        this.setState({shipment: {...this.state.shipment, additionalServices: services}});
    }

    redirectPrice = () => {
        return this.state.RedirectPrice.redirectionServices.reduce((sum, rp) => sum + parseFloat(rp.priceInclGST||"0.0"),0.0);
    }

    isReceiverPrice = (as) => {
        return (as.priceInclGST >= 0 && !as.paid_by && !as.justpaid);
    }

    additionalServicePrice = () => {
        return this.state.shipment.additionalServices.reduce((sum, as) => sum + ((this.isReceiverPrice(as) && as.selected === true) ? parseFloat(as.priceInclGST||"0.0") : 0.0),0.0);
    }

    totalPrice = () =>  {
        return `$${UtilService.roundMoneyTo((this.additionalServicePrice() + this.redirectPrice()), 2)}`;
    }

    setAddressType = (newAddressType) => {
        console.log('newAddressType', newAddressType);
        this.setState({to: {...this.state.to, Address:{...this.state.to.Address, address_type: newAddressType.value}}}); 
    }

    async componentDidMount() {   
        let configTask = ConfigService.getConfig();
        await this.loadOffer();
        await this.loadServices();
        let config = await configTask;
        this.setState({loaded: true, config: {...this.state.config, ...config}});  
    }

    async loadOffer() {
        let offer = await (await window.fetch('api/offer/' + this.state.params.jobid)).json();
        this.setOffer(offer);
        return offer;
    }

    setOffer(newOffer) {
        //console.log('offer details', newOffer);
        if (newOffer.location){
            this.setState({location: newOffer.location});
        }
        if (newOffer.shipment){
            this.setState({shipment: newOffer.shipment});
            // also need to set to name from existing
            console.log('newOffer.shipment.to.line1', newOffer.shipment.to.line1);
            if(newOffer.shipment.to.line1)
                this.setState({to: {...this.state.to, Address: {...this.state.to.Address, Name: newOffer.shipment.to.line1}}});
        }
        if (newOffer.offer){
            this.setState({offer: newOffer.offer});
        }
        else if (newOffer.status === 404) {
            this.setState({
                notFound: true
            });
        }
    }

    changeAdditionalService = (selectedCode) => {
        this.setState({
            // Don't mutate state
            shipment: {...this.state.shipment, additionalServices: this.state.shipment.additionalServices.map(as => ({
                ...as,
                // Toggle the one that's been clicked  
                selected: (as.code === selectedCode) ? !as.selected : as.selected
            }))}            
        });
    }

    toggleTCs = () => {
        this.setState({
            acceptTerms: !this.state.acceptTerms
        });
    }

    getUser = async () => {
        if(!this.authService)
            this.authService = await AuthService.getInstance();
        return await this.authService.getUser();
    }

    validateAndCalculatePrice = async () => {
        //console.log('this.state', this.state);
        this.props.setGlobalBusy();
        // need to ensure we have a valid address and name, mobile, email
        if(!this.state.to.Address || this.state.to.Address.Id == 0 || !this.state.to.Contact 
            || !this.state.to.Contact.Name || this.state.to.Contact.Name.length < 2
            || !this.state.to.Contact.Mobile || this.state.to.Contact.Mobile.length < 2 
            || !this.state.to.Contact.Email || this.state.to.Contact.Email.length < 2
            || !this.state.to.Address.Name || this.state.to.Address.Name.length < 2){
            alert('Please ensure you have entered a valid address and contact details.');
            this.props.clearGlobalBusy();
            return;
        }

        var user = await this.getUser();

        if(user){
            const headers = new Headers();
            headers.append('Content-Type', 'application/json');
            headers.append('Authorization', `Bearer ${user.access_token}`);
            //first get price, and assuming nothing goes wrong move to confirmation state
            var response = await window.fetch(`api/offer/${this.state.params.jobid}/redirectprice`,
            {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({ token: this.state.params.jobid, toAddress:  this.state.to.Address})
            });
            if(!response.ok) {
                if(response.status == "409"){
                    alert("Sorry this is out of date; Tap to refresh.");
                    return this.loadOffer();
                }
                else{
                    alert("Error: " + await response.text());
                    this.props.clearGlobalBusy();
                    return;
                }
            }
            try {
                const result = await response.json();
                console.log('Got redirection price object!', result);
                // set redirect price and also update current shipment with the current additional services pricing
                this.setState({RedirectPrice: result, shipment: {...this.state.shipment, additionalServices: result.additionalServices}});                
            }
            catch(err) {
                alert('Error getting price... leaving as default');
            }
        }
        else {
            alert('Failed to calculate price... leaving as default');
        }
        this.props.clearGlobalBusy();
        this.setState({confirm: true});
    }

    startPayment = async() => { 
        this.props.setGlobalBusy();
        //check if we're logged in
        let user;
        try{
            user = await this.getUser();
        }
        catch(err) {
            alert('Please login (or register) to do this.');
            this.props.clearGlobalBusy();
            return;
        }
        
        if(this.state.acceptTerms !== true){
            alert("Please confirm you have read and accept our T&Cs");
            this.props.clearGlobalBusy();
            return;
        }
        try{
            const paymentDetails = await this.postData('api/offer/' + this.state.params.jobid + '/startpayment', 
                {to: this.state.to, shipment: this.state.shipment, isRedirect: true}, user.access_token);
            if(paymentDetails && paymentDetails.paymentPageUrl) {
                console.log('payment page details', paymentDetails);
                this.props.clearGlobalBusy();
                window.location.href = paymentDetails.paymentPageUrl;
            }
        }
        finally {
            this.props.clearGlobalBusy();
        }
    }

    postData(url = '', data = {}, accessToken = null) {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        if(accessToken)
            headers.append('Authorization', `Bearer ${accessToken}`);

        return fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: headers,
            redirect: 'follow',
            referrer: 'no-referrer',
            body: JSON.stringify(data),
        })
        .then(async response => {
             console.log('response', response);
            if(!response.ok) {
                if(response.status == "409"){
                    alert("Sorry this is out of date; Tap to refresh.");
                    return this.loadOffer();
                }
                if(response.status == "401"){
                    alert("Please login or register to do this.");
                    return null;
                }
                else{
                    var errorDetail = await response.json();
                    console.error('Error', errorDetail)
                    alert("Sorry; Error starting payment");
                    return null;
                }
            }
            return response.json();
        });
    }

    render() {
        return (
            this.state.notFound === true ?
            <div>
                <div className="header">My Delivery: NOT FOUND</div>
                <div style={{textAlign: "center"}}>Shipment Not Found</div>
            </div> :
            <div className="additional-services">
                <div className="header">My Delivery: CHANGE DELIVERY ADDRESS</div>
                {!this.state.loaded && <div>Loading...</div>}
                {this.state.loaded &&
                <div>
                    <div className="view-body">
                        <div className="edit-icon-right">
                            <Address label="We have a parcel for you from" address={{line1: this.state.shipment.from.line1}} />
                            <div><i className="icon-x-app-icon connote"></i></div>
                        </div>
                        <div>
                            <label>Consignment Number</label>
                            <div className="fakeinput">
                                {this.state.shipment.connote}
                            </div>
                            <div style={{marginTop: "0.4em"}} />
                        </div>
                        {!this.state.confirm &&
                        <div>                            
                            <ActivityLocation activityLocation={this.state.to} onActivityLocationChanged={e=>this.setState({to: {...this.state.to, ...e}})} />
                            <AuthorityToLeave type="checkbox" offer={this.state.offer} shipment={this.state.shipment} 
                                updateShipment={e=>this.setState({shipment: {...this.state.shipment, ...e}})} config={this.state.config}></AuthorityToLeave>
                            <div style={{marginTop: "0.4em"}} />
                            <div className="header">New Delivery Contact</div>
                            <fieldset>
                                <div className="form-group">
                                    <label>Name</label>
                                    <input type="text" className="form-control" value={this.state.to.Contact.Name} onChange={e => this.setState({to: {...this.state.to, Contact: {...this.state.to.Contact, Name: e.target.value}}})} />
                                </div>
                                <div className="form-group">
                                    <label>Mobile</label>
                                    <input type="text" className="form-control" value={this.state.to.Contact.Mobile} onChange={e => this.setState({to: {...this.state.to, Contact: {...this.state.to.Contact, Mobile: e.target.value}}})} />
                                </div>
                                <div className="form-group">
                                    <label>Email Address</label>
                                    <input type="text" className="form-control" value={this.state.to.Contact.Email} onChange={e => this.setState({to: {...this.state.to, Contact: {...this.state.to.Contact, Email: e.target.value}}})} />
                                </div>
                            </fieldset>                                
                            <div className="action-area">
                                <div className="clearfix">
                                    <AppButton ajaxInProgress={this.props.busy} iconName="icon-function-right-arrow-up" footer="Tap here when done entering new address" actionText="Next" 
                                        onClick={this.validateAndCalculatePrice}/>
                                    <AppButton function iconName="icon-function-left-arrow-up" actionText="Back" 
                                        onClick={() => { this.props.history.push('../../ao/' + this.state.params.jobid)  }} footer="Return to options"/>
                                </div>
                            </div>
                        </div>}
                        {this.state.confirm === true && 
                            <ConfirmRedirect busy={this.props.busy} acceptTerms={this.state.acceptTerms} toggleTCs={this.toggleTCs} 
                                changeAdditionalService={(id) => this.changeAdditionalService(id)} isReceiverPrice={(as) => this.isReceiverPrice(as)}
                                offer={this.state.offer}
                                costs={this.state.RedirectPrice.redirectionServices} services={this.state.shipment.additionalServices} to={this.state.to} 
                                shipment={this.state.shipment} redirectPrice={this.redirectPrice} totalPrice={this.totalPrice} config={this.state.config}
                                startPayment={this.startPayment} onBack={() => {this.setState({confirm: false});}}></ConfirmRedirect>
                        }
                    </div>
                </div>}
            </div>
        );
    }
}

export default withRouter(Redirect);
